<hmf-snackbar
	#snackbar
	class="hmf-position-fixed plp-snackbar"
	[dismissDelay]="5"
	[action]="'auto-dismiss'"
	[linkType]="'event'"
	[type]="'error'">
	<span class="hmf-body-l">{{ snackbarMessage$ | async }}</span>
</hmf-snackbar>
